/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_RulesetInputs */

const en_entity_ruleset = /** @type {(inputs: Entity_RulesetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruleset`)
};

const de_entity_ruleset = /** @type {(inputs: Entity_RulesetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regelsatz`)
};

/**
* | output |
* | --- |
* | "Ruleset" |
*
* @param {Entity_RulesetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_ruleset = /** @type {((inputs?: Entity_RulesetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_RulesetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_ruleset(inputs)
	return de_entity_ruleset(inputs)
});